<template>
  <div v-show="show" :style="{ 'z-index': (currentZIndex-1)}">
    <div :style="{ 'z-index': (currentZIndex)}"
      class="dimmed_black" style="top:0;display:block;"></div>
    
    <div :style="{ 'z-index': (currentZIndex+1)}"
      class="rew19_popContainer big" style="display:block;">
      <div class="rew19_popup_wrap">
        <h2>
          <span class="rew19_basketList_tit">재결제 진행({{adr_no}})</span>
          <button class="rew19_basketList_btn" @click="onCancel"><span>닫기</span></button>
        </h2>
      </div>
      <div class="rew19_popup_cont">
        <ul class="rew19_dotList topGep">
          <li>기존 결제 방식을 변경하기 원하시면 나의 에이지락미 주문내역에서 해당 약정을 찾아 변경 후 재결제를 다시 진행해 주시기 바랍니다.</li>
          <li>에이지락 미 커스텀 프로덕트 세트 결제를 위해 필요한 마일리지는 커스텀 프로덕트 134.5 + 배송비 2.1로 총 136.6 마일리지 입니다. 보유하신 마일리지가 부족할 경우 마일리지로 재결제를 진행할 수 없습니다.</li>
          <li>리워드 그레이스(약정 유예기간)는 리워드 프로그램 유지기간 중 총 2회(비연속 2개월)에 한해 사용 가능합니다.</li>
        </ul>

        <ul class="rew19_underline_list type3">
          <li class="type2">
            <em class="longType">현재 보유 마일리지</em>
            <span class="substance">{{$fmt.PV(viewData.aro_info.ownMileage, "-")}}</span>
          </li>
          <li class="type2">
            <em class="longType">리워드 그레이스 사용</em>
            <span class="substance">{{$nvl(viewData.aro_info.use_date, "-")}}</span>
          </li>
        </ul>

        <h3 class="rew19_third_title">결제방식 선택</h3>

        <ul class="rew19_underline_list">
          <li class="type1">
            <div class="rew19_wrapRadio_t1">
              <input  
                v-model.number="viewData.rePaymentMethod"
                :value="1"
                type="radio" class="rew19_fakeRadio_t1" id="repayment_method_1">
              <label for="repayment_method_1">기존 결제 방식 {{viewData.paymentTypeName}}</label>
            </div>
          </li>
          <!--//최진혁 과장님 요청에 의해 그레이스는 무조건 활성화-->
          <li class="type1">
            <div class="rew19_wrapRadio_t1">
              <input 
                v-model.number="viewData.rePaymentMethod"
                :value="2"
                type="radio" class="rew19_fakeRadio_t1" id="repayment_method_2">
              <label for="repayment_method_2">리워드 그레이스</label>
            </div>
          </li>          
          <li v-if="AroConst.VALUE_mileage_status_APPLY == viewData.aro_info.mileage_status"
            class="type1">
            <div class="rew19_wrapRadio_t1">
              <input 
                v-model.number="viewData.rePaymentMethod"
                :value="3"
                type="radio" class="rew19_fakeRadio_t1" id="repayment_method_3">
              <label for="repayment_method_3">리워드 마일리지 결제</label>
            </div>
          </li>
        </ul>
                    
      </div><!--//rew19_popup_cont-->
      <div class="rew19_popup_btn rew19_clear">
        <button class="rew19_popHarf disabled" @click="onCancel">취소</button>
        <button class="rew19_popHarf activation" @click="onProcess">확인</button>
      </div>        
    </div>

    <ageloc-mileage-payment-dialog
      :show="agelocMileagePaymentDialogShow"      
      @close="agelocMileagePaymentClose"
      ref="agelocMileagePaymentDialog"
    ></ageloc-mileage-payment-dialog>
  </div>  
</template>
<script>
import AroBase from '@/components/base/AroBase';
import AgelocMileagePaymentDialog from '@/components/popup/AgelocMileagePaymentDialog';

import * as ErrMsg from "@/utils/error_msg";

const DEFAULT_VIEWDATA = {  
  aro_info : {},

  rePaymentMethod : 1, //1:기존결제 방식, 2:리워드 그레이스, 3:리워드 마일리지 결제
  paymentTypeName : ""
};

export default {
  name: 'AgelocRepaymentDialog',
  extends: AroBase,
  components: { AgelocMileagePaymentDialog },
  props: {
    show: {
      type: Boolean,
      default: false
    }    
  },
  data() {
    return {
      currentZIndex : 2000,

      adr_no : null,
      adr_order_no : null,
      payment_target : null,
      payment_typ : null,

      viewData : {...DEFAULT_VIEWDATA},
      
      agelocMileagePaymentDialogShow : false,
      agelocMileagePaymentDialog : {}
    }
  },
  watch: {
    show(show) {
      this.$modalAfterTreat(show);

      show && this.$nextTick(() => {
        let _this = this;
        _this.currentZIndex = _this.$getDimmMaxIndex() + 2;

        this.$el.focus();
      })
    }
  },
  updated: function () {
    this.$nextTick(function () {
      $(".rew19_popContainer.big .rew19_popup_cont").css('height', $(window).height() - 102); 
    })
  },
  mounted() {
    let _this = this;

  },  
  methods :{
    onClose(response) {
      let _this = this;
      _this.agelocMileagePaymentDialogShow = false;
      
      let resData = {};
      
      _this.$emit('close', response, response ? resData: null);      
    },
    onCancel(){
      this.onClose(false);
    },
    onOk() {
      this.onClose(true);
    },

    /**
     * API Request
     */    
    //나의 에이지락 미 정보 가져오기
    apiGetAgelocmeDetail(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/get_agelocme_detail`, {
        params: {
          adr_no : _this.adr_no
        }
      });
    },  
    
    //나의 에이지락 미 재결제
    apiRepayAgelocme(repayData){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/repay_agelocme`, {
        params: {
          adr_no : _this.adr_no,
          adr_order_no : _this.adr_order_no,
          payment_target : _this.payment_target, //결제 기준월
          payment_typ : _this.payment_typ, //결제 방법
          ...repayData // 추가 결제 데이터
        }
      });
    },  

    /**
     * Local 
     */
    initData : function(paramData){
      let _this = this;

      //재결제 기본 정보
      _this.adr_no = paramData.adr_no;
      _this.adr_order_no = paramData.adr_order_no;
      _this.payment_target = paramData.payment_target;
      _this.payment_typ = paramData.payment_typ;

      _this.viewData = {
        ...DEFAULT_VIEWDATA,
      };

      _this.loadAroDetail();
    },

    //결제 방법에 따른 처리
    onProcess(){
      let _this = this;
      let rePayData = {};

      switch(_this.viewData.rePaymentMethod){
        case 1:
          //기존결제 방식
          rePayData = {...rePayData,
            addpaymenttype : _this.AroConst.VALUE_addpaymenttype_EXIST,
          };

          break;
        case 2:
          //그레이스 사용
          rePayData = {...rePayData,
            addpaymenttype : _this.AroConst.VALUE_addpaymenttype_GRACE,
          };

          break;

        case 3:
          //리워드 마일리지 결제
          _this.agelocMileagePaymentDialog = {
            adr_no : _this.adr_no,
            adr_order_no : _this.adr_order_no,
            aro_info : _this.viewData.aro_info
          };
          _this.$refs.agelocMileagePaymentDialog.initData(_this.agelocMileagePaymentDialog);
          _this.agelocMileagePaymentDialogShow = true;
          return;
      }

      //재결제 처리
      _this.rePayment(rePayData);
    },

    //Aro 상세정보 로드
    loadAroDetail(){
      let _this = this;

      //show loading
      _this.$showLoading();      
      _this.apiGetAgelocmeDetail().then(res=>{
        if (res.status === 200 && res.data.status === "0000") {

          _this.viewData.aro_info = {
            ...res.data
          };

          _this.viewData.paymentTypeName = "";
          if(_this.AroConst.VALUE_payment_type_credit_card == _this.viewData.aro_info.payment_type){
            _this.viewData.paymentTypeName = "( 카드결제 )";
          }else if(_this.AroConst.VALUE_payment_type_account_transfer == _this.viewData.aro_info.payment_type){
            _this.viewData.paymentTypeName = "( 자동이체 )";
          }

          

        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }

      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});        

      }).finally(()=>{
        //hide loading
         _this.$hideLoading();
      });
    },

    //재결제
    rePayment(repayData){
      let _this = this;
      
      //재결제 처리
      _this.$showLoading();
      _this.apiRepayAgelocme(repayData).then(res=>{
        let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
        
        if(res.status === 200 && res.data.status === "0000"){
          _this.$dialogs.alert("재결제가 완료 되었습니다.")
          .then(res => {});

          _this.onClose(true, retVal);
          return;
        }

        _this.$dialogs.alert(errMsg)
        .then(res => {});

      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});        

      }).finally(()=>{
        _this.$hideLoading();
      });
    },

    //마일리지 결제
    agelocMileagePaymentClose(isOk, repayData){
      let _this = this;

      if(!isOk){
        _this.agelocMileagePaymentDialogShow = false;

        //Do nothing
        return;
      }
      
      _this.rePayment(repayData);
    },    

    /**
     * Util
     */    
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/popup/AgelocRepaymentDialog.vue